import { icon } from '@fortawesome/fontawesome-svg-core';
import { faBookmark as farBookmark } from '@fortawesome/pro-regular-svg-icons';
import { faBookmark as fasBookmark } from '@fortawesome/pro-solid-svg-icons';

async function toggleSaveOfResource(data) {
    return await fetch("/account/save-resource/", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
            resource_id: data.resourceId,
            resource_type: data.resourceType,
            to_save: data.toSave
        })
    })
}

document.addEventListener("DOMContentLoaded", () => {
    const saveButtons = document.querySelectorAll(".c-save-resource__button");
    saveButtons.forEach(button => {
        button.addEventListener("click", async (event) => {
            event.preventDefault();

            const buttonContainer = button.closest(".c-save-resource");
            const userAuthenticated = buttonContainer.getAttribute("data-authenticated-user") === "true";

            if (!userAuthenticated) {
                alert("You must be logged in to save resources.");
                return;
            }

            const resourceId = parseInt(buttonContainer.getAttribute("data-resource-id"));
            const resourceType = buttonContainer.getAttribute("data-resource-type");
            const toSave = button.getAttribute("data-to-save") === "true";

            const response = await toggleSaveOfResource({
                resourceId,
                resourceType,
                toSave
            });

            if (!response.ok) {
                console.error("Failed to toggle save state:", response.statusText);
                alert("An error occurred while saving the resource. Please try again.");
                return;
            }

            const responseData = await response.json();
            if (!responseData.success) {
                console.error("Error in response data:", responseData);
                alert("An error occurred while saving the resource. Please try again.");
                return;
            }
            console.log("Resource save state toggled successfully:", responseData);

            const isNowSaved = !toSave;

            button.setAttribute("data-to-save", isNowSaved.toString());
      
            // Swap label
            const label = button.querySelector(".c-save-resource__label--save, .c-save-resource__label--saved");
            if (label) label.textContent = !isNowSaved ? "Saved" : "Save";

            // Swap class
            button.classList.toggle("c-btn", !isNowSaved);
            button.classList.toggle("c-save-resource__button--saved", !isNowSaved);
            //button.classList.toggle("c-activities__btn--save", isNowSaved);
            button.classList.toggle("c-save-resource__button--save", isNowSaved);

            // Swap icon
            const existingIcon = button.querySelector("svg");
            if (existingIcon) existingIcon.remove();

            const newIcon = icon(isNowSaved ? farBookmark : fasBookmark).node[0];

            if (label && isNowSaved) {
                button.insertBefore(newIcon, button.querySelector("span"));
            } else {
                button.appendChild(newIcon);
            }
                
        });
    })
})